import {
  type FillLayerSpecification,
  type LineLayerSpecification,
} from '@aus-platform/cesium';
import { type TerrainCleanupFormType } from './types';

export const cleanupFormInitialState: TerrainCleanupFormType = {
  workspaceLayer: null,
  cleanupName: '',
};

export const polygonLayersTemplate: (
  | FillLayerSpecification
  | LineLayerSpecification
)[] = [
  {
    id: 'polygons',
    type: 'fill',
    source: '',
    'source-layer': 'default',
    paint: {
      'fill-color': '#F9CC34',
      'fill-opacity': 0,
    },
    filter: ['==', 'type', 'Polygon'],
  },
  {
    id: 'polygon-boundary',
    type: 'line',
    source: '',
    'source-layer': 'default',
    paint: {
      'line-color': '#F9CC34',
      'line-width': 3,
    },
    filter: ['==', 'type', 'Polygon'],
  },
];
